export default "__VITE_ASSET__CeLCpPvY__"